import { createTheme } from '@mui/material/styles';
// Create a theme instance.
const theme = createTheme(
  {
    "breakpoints": {
      "keys": [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
      ],
      "values": {
        "xs": 0,
        "sm": 600,
        "md": 900,
        "lg": 1200,
        "xl": 1536
      },
      "unit": "px"
    },
    "direction": "ltr",
    // "components": {},
    "palette": {
      "mode": "light",
      "common": {
        "black": "#000",
        "white": "#fff"
      },
      "primary": {
        "main": "#3b82f6",
        "light": "#bfdbfe",
        "dark": "#1d4ed8",
        "contrastText": "#fff"
      },
      "secondary": {
        "main": "#1e293b",
        "light": "#e2e8f0",
        "dark": "#0f172a",
        "contrastText": "#fff"
      },
      "error": {
        "main": "#f43f5e",
        "light": "#fda4af",
        "dark": "#be123c",
        "contrastText": "#fff"
      },
      "warning": {
        "main": "#f59e0b",
        "light": "#facc15",
        "dark": "#e65100",
        "contrastText": "#fff"
      },
      "info": {
        "main": "#06b6d4",
        "light": "#67e8f9",
        "dark": "#0e7490",
        "contrastText": "#fff"
      },
      "success": {
        "main": "#34d399",
        "light": "#6ee7b7",
        "dark": "#047857",
        "contrastText": "#fff"
      },
      "grey": {
        "50": "#fafafa",
        "100": "#f5f5f5",
        "200": "#eeeeee",
        "300": "#e0e0e0",
        "400": "#bdbdbd",
        "500": "#9e9e9e",
        "600": "#757575",
        "700": "#616161",
        "800": "#424242",
        "900": "#212121",
        "A100": "#f5f5f5",
        "A200": "#eeeeee",
        "A400": "#bdbdbd",
        "A700": "#616161"
      },
      "contrastThreshold": 3,
      "tonalOffset": 0.2,
      "text": {
        "primary": "#0f172a",
        "secondary": "#64748b",
        "disabled": "#cbd5e1"
      },
      "divider": "rgba(0, 0, 0, 0.12)",
      "background": {
        "paper": "#fff",
        "default": "#ffffff"
      },
      "action": {
        "active": "rgba(0, 0, 0, 0.54)",
        "hover": "rgba(0, 0, 0, 0.04)",
        "hoverOpacity": 0.04,
        "selected": "rgba(0, 0, 0, 0.08)",
        "selectedOpacity": 0.08,
        "disabled": "rgba(0, 0, 0, 0.26)",
        "disabledBackground": "rgba(0, 0, 0, 0.12)",
        "disabledOpacity": 0.38,
        "focus": "rgba(0, 0, 0, 0.12)",
        "focusOpacity": 0.12,
        "activatedOpacity": 0.12
      }
    },
    "shape": {
      "borderRadius": 4
    },
    "status": {
      "danger": "#f00"
    },
    "unstable_sxConfig": {
      "border": {
        "themeKey": "borders"
      },
      "borderTop": {
        "themeKey": "borders"
      },
      "borderRight": {
        "themeKey": "borders"
      },
      "borderBottom": {
        "themeKey": "borders"
      },
      "borderLeft": {
        "themeKey": "borders"
      },
      "borderColor": {
        "themeKey": "palette"
      },
      "borderTopColor": {
        "themeKey": "palette"
      },
      "borderRightColor": {
        "themeKey": "palette"
      },
      "borderBottomColor": {
        "themeKey": "palette"
      },
      "borderLeftColor": {
        "themeKey": "palette"
      },
      "outline": {
        "themeKey": "borders"
      },
      "outlineColor": {
        "themeKey": "palette"
      },
      "borderRadius": {
        "themeKey": "shape.borderRadius"
      },
      "color": {
        "themeKey": "palette"
      },
      "bgcolor": {
        "themeKey": "palette",
        "cssProperty": "backgroundColor"
      },
      "backgroundColor": {
        "themeKey": "palette"
      },

      "displayPrint": {
        "cssProperty": false
      },

      "zIndex": {
        "themeKey": "zIndex"
      },

      "boxShadow": {
        "themeKey": "shadows"
      },
      "fontFamily": {
        "themeKey": "typography"
      },
      "fontSize": {
        "themeKey": "typography"
      },
      "fontStyle": {
        "themeKey": "typography"
      },
      "fontWeight": {
        "themeKey": "typography"
      },

      "typography": {
        "cssProperty": false,
        "themeKey": "typography"
      }
    },
    "mixins": {
      "toolbar": {
        "minHeight": 56,
        "@media (min-width:0px)": {
          "@media (orientation: landscape)": {
            "minHeight": 48
          }
        },
        "@media (min-width:600px)": {
          "minHeight": 64
        }
      }
    },
    "shadows": [
      "none",
      //   "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

      //   "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)"
      'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',

    ],
    "typography": {
      "htmlFontSize": 16,
      "fontFamily": "Poppins",
      "fontSize": 14,
      "fontWeightLight": 300,
      "fontWeightRegular": 400,
      "fontWeightMedium": 500,
      "fontWeightBold": 700,
      "h1": {
        "fontFamily": "Poppins",
        "fontWeight": 500,
        "fontSize": "6rem",
        "lineHeight": 1.167,
        "letterSpacing": "-0.01562em"
      },
      "h2": {
        "fontFamily": "Poppins",
        "fontWeight": 500,
        "fontSize": "3.75rem",
        "lineHeight": 1.2,
        "letterSpacing": "-0.00833em"
      },
      "h3": {
        "fontFamily": "Poppins",
        "fontWeight": 600,
        "fontSize": "3rem",
        "lineHeight": 1.167,
        "letterSpacing": "0em"
      },
      "h4": {
        "fontFamily": "Poppins",
        "fontWeight": 600,
        "fontSize": "2.125rem",
        "lineHeight": 1.235,
        "letterSpacing": "0.00735em"
      },
      "h5": {
        "fontFamily": "Poppins",
        "fontWeight": 600,
        "fontSize": "1.5rem",
        "lineHeight": 1.334,
        "letterSpacing": "0em"
      },
      "h6": {
        "fontFamily": "Poppins",
        "fontWeight": 600,
        "fontSize": "1.4rem",
        "lineHeight": 1.6,
        "letterSpacing": "0.0075em"
      },
      "subtitle1": {
        "fontFamily": "Poppins",
        "fontWeight": 400,
        "fontSize": "1rem",
        "lineHeight": 1.75,
        "letterSpacing": "0.00938em"
      },
      "subtitle2": {
        "fontFamily": "Poppins",
        "fontWeight": 500,
        "fontSize": "0.875rem",
        "lineHeight": 1.57,
        "letterSpacing": "0.00714em"
      },
      "body1": {
        "fontFamily": "Poppins",
        "fontWeight": 300,
        "fontSize": "1.2rem",
        "lineHeight": 1.5,
        "letterSpacing": "0.00938em"
      },
      "body2": {
        "fontFamily": "Poppins",
        "fontWeight": 300,
        "fontSize": "0.875rem",
        "lineHeight": 1.43,
        "letterSpacing": "0.01071em"
      },
      "button": {
        "fontFamily": "Poppins",
        "fontWeight": 500,
        "fontSize": "0.875rem",
        "lineHeight": 1.75,
        "letterSpacing": "0.02857em",
        "textTransform": "uppercase"
      },
      "caption": {
        "fontFamily": "Poppins",
        "fontWeight": 400,
        "fontSize": "0.75rem",
        "lineHeight": 1.66,
        "letterSpacing": "0.03333em"
      },
      "overline": {
        "fontFamily": "Poppins",
        "fontWeight": 400,
        "fontSize": "0.75rem",
        "lineHeight": 2.66,
        "letterSpacing": "0.08333em",
        "textTransform": "uppercase"
      },
      "inherit": {
        "fontFamily": "inherit",
        "fontWeight": "inherit",
        "fontSize": "inherit",
        "lineHeight": "inherit",
        "letterSpacing": "inherit"
      }
    },
    "transitions": {
      "easing": {
        "easeInOut": "cubic-bezier(0.4, 0, 0.2, 1)",
        "easeOut": "cubic-bezier(0.0, 0, 0.2, 1)",
        "easeIn": "cubic-bezier(0.4, 0, 1, 1)",
        "sharp": "cubic-bezier(0.4, 0, 0.6, 1)"
      },
      "duration": {
        "shortest": 150,
        "shorter": 200,
        "short": 250,
        "standard": 300,
        "complex": 375,
        "enteringScreen": 225,
        "leavingScreen": 195
      }
    },
    "zIndex": {
      "mobileStepper": 1000,
      "fab": 1050,
      "speedDial": 1050,
      "appBar": 1100,
      "drawer": 1200,
      "modal": 1300,
      "snackbar": 1400,
      "tooltip": 1500
    },
    "components": {
      'MuiPaper': {
        'styleOverrides': {
          'root': {
            'borderRadius': '.5rem',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'primary' && {
              backgroundColor: 'none',
              color: '#fff',
              backgroundSize: '300% 100%',
              transition: 'all .2s ease-in',
              backgroundImage: 'linear-gradient(to right, #3b82f6, #2563eb, #1d4ed8, #2563eb)',
              // boxShadow: '0 4px 15px 0 rgba(65, 132, 234, 0.75)',
              position: 'relative',
              zIndex: 2,
              bottom: 0,
              "&:hover": {
                backgroundPosition: '100% 0%',
                // boxShadow: '0 4px 15px 0 rgba(65, 132, 234, 0.75)',
              bottom: '4px'

              },
            }),
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'secondary' && {
              backgroundColor: 'none',
              backgroundImage: 'linear-gradient(to right, #60a5fa, #93c5fd, #60a5fa, #93c5fd, #60a5fa)',
              color: '#fff',
              backgroundSize: '300% 100%',
              transition: 'all .4s ease-in-out',
              position: 'relative',
              zIndex: 2,
              bottom: 0,
              "&:hover": {
                backgroundPosition: '100% 0%',
              bottom: '4px'
              },
            }),
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'error' && {
              backgroundColor: 'none',
              backgroundImage: 'linear-gradient(to right, #fb7185, #fa697e, #f96077, #f7576f, #f64d68, #f7536c, #f7586f, #f85d73, #fa7082, #fc8291, #fd93a0, #fda4af);',
              color: '#fff',
              backgroundSize: '300% 100%',
              transition: 'all .4s ease-in-out',
              position: 'relative',
              zIndex: 2,
              bottom: 0,
              "&:hover": {
                backgroundPosition: '100% 0%',
              bottom: '4px'
              },
            }),
          }),
        },
      },
    }
  }
);
export default theme;
